import { useFeatureFlagContextSync } from '@trm/feature-flags/web';
import useAuth from '~/hooks/useAuth';

const LaunchDarklyUserIdentifier = ({ children }: { children: React.ReactNode }) => {
  const { user, isInitialized } = useAuth();
  const offline = process.env.USE_LOCAL_FEATURE_FLAGS === 'true';

  useFeatureFlagContextSync(
    !offline && isInitialized && user && user.userId
      ? {
          targetingKey: user.userId.toString(),
          anonymous: false,
          name: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
          firstName: user.firstName || '',
          lastName: user.lastName || '',
          email: user.email || '',
          isVerified: !user.needsVerification,
          isLocked: user.isLocked,
          lockType: user.lockType,
          role: user.role,
          createdAt: user.createdAt ? new Date(user.createdAt).getTime() : null,
        }
      : null,
  );

  return <>{children}</>;
};

export default LaunchDarklyUserIdentifier;
